import {
  matchElementHeight
} from './_matchElementHeight';
import {
  Validate
} from './_formValidation';

export const managePopover = () => {
  var $dataToggle = $('[data-toggle="popover"]');

  if (typeof popover == 'function') {
    $dataToggle.popover({
      trigger: 'manual',
      placement: 'top'
    }).mousedown(function(e) {
      $(this).popover('show');
    }).mouseout(function(e) {
      $(this).popover('hide');
    });
  }

  var lowercaseEmailCheck = function() {
    $('#choose-email, #confirm-email-address, #logonId, #myDillardsMyEmail, #inputEmail, #quick-checkout-email, #recipientEmail').on('blur focus', function() {

      $(this).val($(this).val().toLowerCase());

    });

//    $('form[action="UserRegistrationUpdate"] input').each(function() {
//      $(this).on('focus', function() {
//        var start = this.selectionStart,
//          end = this.selectionEnd;
//        this.setSelectionRange(start, end);
//      });
//    });
  };

  var passwordValidation = function() {
    var $dapValidate = Validate;
    if ($('.personal-info-page').length > 0) {
      $('#create-password').on('focus', function() {
          $('#password-strength').show();
      });
    };
    $('#new-password, #choose-password, #create-password').on('keyup', function() {
      var $numCharacters = $('.number-characters'),
        $oneNumber = $('.one-number'),
        $lowerCase = $('.one-lower-case-letter'),
        $upperCase = $('.one-upper-case-letter'),
        $englishNoPeriods = $('.english-only-no-periods'),
        $pwStrengthRating = $('.strength-rating');
      var between8and16chars = $dapValidate.isBetween8and16chars(this.value),
        goodNumeric = $dapValidate.hasANumber(this.value),
        goodUpperCase = $dapValidate.hasUpperCase(this.value),
        goodLowerCase = $dapValidate.hasLowerCase(this.value),
        goodAscii = $dapValidate.badAsciiCheck(this.value) && $dapValidate.prohibitedCharacters(this.value),
        goodChar = $dapValidate.prohibitedCharacters(this.value),
        pwStrengthRating = $dapValidate.getPasswordStrength(this.value);
      const pwReqUpdate = (pwReq, reqLine) => {
        const updateCompletion = (zmdiCircle1, zmdiCircle2, status1, status2) => {
          reqLine.find('i').removeClass(zmdiCircle1);
          reqLine.removeClass(status1);
          reqLine.find('i').addClass(zmdiCircle2);
          reqLine.addClass(status2);
        };
        (pwReq) ? updateCompletion('zmdi-close-circle', 'zmdi-check-circle', 'incomplete', 'completed'): updateCompletion('zmdi-check-circle', 'zmdi-close-circle', 'completed', 'incomplete');
      }
      pwReqUpdate(between8and16chars, $numCharacters);
      pwReqUpdate(goodNumeric, $oneNumber);
      pwReqUpdate(goodUpperCase, $upperCase);
      pwReqUpdate(goodLowerCase, $lowerCase);
      pwReqUpdate(goodAscii, $englishNoPeriods);
      (pwStrengthRating == "Strong") ? $pwStrengthRating.text('Strong'): $pwStrengthRating.text('Weak');
    });
    $('#verify-new-password, #verify-choose-password').on('focus, keyup', function() {
      var newPw = $('#new-password').val(),
          verifyPw = $('#verify-new-password').val(),
          validationPin = '';

      if(typeof $('#validationPin').val() !== 'undefined'){
        validationPin = $('#validationPin').val();
      }
          
          

      var between8and16chars = $dapValidate.isBetween8and16chars(this.value),
        goodNumeric = $dapValidate.hasANumber(this.value),
        goodUpperCase = $dapValidate.hasUpperCase(this.value),
        goodLowerCase = $dapValidate.hasLowerCase(this.value),
        goodAscii = $dapValidate.badAsciiCheck(this.value),
        goodChar = $dapValidate.prohibitedCharacters(this.value),
        goodPin = $dapValidate.isValidResetPasswordPin(validationPin);

        if (newPw !== '' && verifyPw !== '' && between8and16chars && goodNumeric && goodUpperCase && goodLowerCase && goodAscii && goodChar) {
            ((newPw == verifyPw) && goodPin) ? enableNewPasswordSubmit(): disableNewPasswordSubmit();
        } else {
            disableNewPasswordSubmit();
        }
    
    });
    $('#validationPin').on('focus, keyup', function() {
      var newPw = $('#new-password').val(),
          verifyPw = $('#verify-new-password').val(),
          validationPin = $('#validationPin').val();
      var between8and16chars = $dapValidate.isBetween8and16chars(verifyPw),
        goodNumeric = $dapValidate.hasANumber(verifyPw),
        goodUpperCase = $dapValidate.hasUpperCase(verifyPw),
        goodLowerCase = $dapValidate.hasLowerCase(verifyPw),
        goodAscii = $dapValidate.badAsciiCheck(verifyPw),
        goodChar = $dapValidate.prohibitedCharacters(verifyPw),
        goodPin = $dapValidate.isValidResetPasswordPin(this.value);

        if (newPw !== '' && verifyPw !== '' && between8and16chars && goodNumeric && goodUpperCase && goodLowerCase && goodAscii && goodChar) {
            ((newPw == verifyPw) && goodPin) ? enableNewPasswordSubmit(): disableNewPasswordSubmit();
        } else {
            disableNewPasswordSubmit();
        }
    
    });
  };

  var enableNewPasswordSubmit = function() {
	    $("#new-password-submit, #choose-password-submit").attr('disabled', false);
	  };

	  var disableNewPasswordSubmit = function() {
	    $("#new-password-submit, #choose-password-submit").attr('disabled', true);
	  };

  passwordValidation();
  matchElementHeight('.address-block:not(".address-block.main-address")', true);
  lowercaseEmailCheck();


};
